import { IconButton, Paper, Tab, Tabs, Tooltip } from "@material-ui/core";
import React from "react";
import { Code, Visibility, PhotoLibrary } from "@material-ui/icons";
import useSignableDocumentsFullScreenEditorStyles from "../hooks/useSignableDocumentsFullScreenEditorStyles";

function SignableDocumentsFullScreenEditorTabs({
  resources,
  viewMode,
  handleTabChange,
  handleOpenMediaLibrary,
}) {
  const classes = useSignableDocumentsFullScreenEditorStyles();
  return (
    <Paper className={classes.tabsContainer}>
      <div className={classes.tabsWrapper}>
        <Tabs
          value={viewMode}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab icon={<Code />} label={resources["HTMLEditor"]} />
          <Tab icon={<Visibility />} label={resources["Preview"]} />
        </Tabs>
      </div>
      <Tooltip title={resources["MediaLibraryTooltip"]}>
        <IconButton onClick={handleOpenMediaLibrary} style={{ marginRight: 8 }}>
          <PhotoLibrary />
        </IconButton>
      </Tooltip>
    </Paper>
  );
}

export default SignableDocumentsFullScreenEditorTabs;
